import _defineProperty from "@babel/runtime/helpers/defineProperty";
export function HttpBaseClient(Base) {
  class AsHttpClient extends Base {
    constructor() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      super(...args);
      _defineProperty(this, "client", void 0);
      this.client = args[0];
    }
    async request(request) {
      const {
        data
      } = await this.client.request(request);
      return data;
    }
  }
  return AsHttpClient;
}
//# sourceMappingURL=HttpBaseClient.js.map